export default "__VITE_ASSET__CdqOadrL__"